import styled from 'styled-components'

const IntegrationFormLabel = styled.label`
	color: ${props => props.theme.textColor} !important;
`

export default IntegrationFormLabel